import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import { RootState, useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import { getSessionPermissions, populateSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoaderData, useNavigate } from "react-router";
import { useSession } from "users/__session/session-context";
import ContactsTab from "users/networking/_views/contacts-tab";
import CoworkersTab from "users/networking/_views/coworkers-tab";
import GroupsTab from "users/networking/_views/groups-tab";
import { PageTab } from "users/networking/_views/network-page-tabs";
import PendingTab from "users/networking/_views/pending-tab";

export default function Network() {
  const [activeTab, setActiveTab] = React.useState(PageTab.Contacts);

  const routeParams = useLoaderData();
  const navigate = useNavigate();
  const dispatch = useAttorneyHubDispatch();
  const session = useSession();
  const sessionPermissions = useSelector(getSessionPermissions);
  const sessionPermissionsLoading = useSelector((state: RootState) => state.permissions.session.loading);
  const sessionPermissionsError = useSelector((state: RootState) => state.permissions.session.error);

  useEffect(() => {
    if (!sessionPermissions && !sessionPermissionsError && !sessionPermissionsLoading) {
      dispatch(populateSessionPermissions({ session }));
    }
  }, [sessionPermissions, sessionPermissionsError, sessionPermissionsLoading]);

  // Handle URL changes
  useEffect(() => {
    if (!session.user?.legalEntityId) return;

    if (routeParams.tab) {
      setActiveTab(routeParams.tab as PageTab);
    } else {
      navigate(`/network/${PageTab.Contacts}`);
    }
  }, [routeParams]);

  if (!sessionPermissions?.includesAccessToNetwork) return <NotAuthorized />;
  if (activeTab === PageTab.Contacts) return <ContactsTab />;
  if (activeTab === PageTab.Coworkers) return <CoworkersTab />;
  if (activeTab === PageTab.Pending) return <PendingTab />;
  if (activeTab === PageTab.Groups) return <GroupsTab />;
}
